import { render } from "./AddUserNamePage.vue?vue&type=template&id=0dc1b9bd&scoped=true"
import script from "./AddUserNamePage.vue?vue&type=script&lang=js"
export * from "./AddUserNamePage.vue?vue&type=script&lang=js"

import "./AddUserNamePage.vue?vue&type=style&index=0&id=0dc1b9bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc1b9bd"]])

export default __exports__